import api from '@pray/shared/utils/api';

export const parseExternalUrl = async (data) => {
  const url = `/web/studio/external-metadata`;
  const response = await api.executePostRequest(url, data);

  return response.data;
};
